"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Init = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var hsOcr_1 = require("../../model/hsOcr");
var service_1 = require("../../../library/base/service");
var Init = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(Init, _super);
    function Init() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = 'OCR卡片识别服务API';
        _this.code = '105016';
        _this.desc = 'OCR卡片识别服务API';
        _this.requestParams = new hsOcr_1.InitRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return Init;
}(service_1.BaseService));
exports.Init = Init;
//# sourceMappingURL=init.js.map